import ELA1_2x from '~images/loggedout/playable-images/ELA-images/1_2x.png';
import ELA2_2x from '~images/loggedout/playable-images/ELA-images/2_2x.png';
import ELAK_2x from '~images/loggedout/playable-images/ELA-images/K_2x.png';
import ELAPrek_2x from '~images/loggedout/playable-images/ELA-images/Pre-K_2x.png';

import Math1_2x from '~images/loggedout/playable-images/Math-images/1_2x.jpg';
import Math2_2x from '~images/loggedout/playable-images/Math-images/2_2x.jpg';
import Math3_2x from '~images/loggedout/playable-images/Math-images/3_2x.jpg';
import Math4_2x from '~images/loggedout/playable-images/Math-images/4_2x.png';
import Math5_2x from '~images/loggedout/playable-images/Math-images/5_2x.png';
import MathK_2x from '~images/loggedout/playable-images/Math-images/K_2x.jpg';
import MathPrek_2x from '~images/loggedout/playable-images/Math-images/Pre-K_2x.jpg';
export const colorCodes = [
  {dark: '#48C8B0', light: '#69D5C1'},
  {dark: '#2284E2', light: '#7AB5EE'},
  {dark: '#FD9B7D', light: '#FECDBE'},
  {dark: '#C56BEB', light: '#E2B5F5'},
  {dark: '#4F52C3', light: '#9D9FFC'},
  {dark: '#FFD34D', light: '#FFE4A7'},
  {dark: '#FD9B7D', light: '#FECDBE'}
]
export const grades = [
  {
  title: 'pk',
  },
  {
    title: 'k',
  },
  {
    title: 1,
  },
  {
    title: 2,
  },
  {
    title: 3,
  },
  {
    title: 4,
  },
  {
    title: 5
  }
]
export const gradesAndContentGroup = {
  'pk' : [
    { 
      image: MathPrek_2x,
      'Math': [
        'Number Sequence',
        'Number Recognition',
        'Number Tracing',
        'Counting Objects',
        'Addition & Subtraction',
        'Shapes',
        'Sorting & Comparing'
      ]
    },
    {
      image: ELAPrek_2x,
      'Reading': [
        'Letter Names and Sounds',
        'Letter Tracing',
        'Letter Sequence',
        'Sight Words',
        'Read Aloud'
      ]
    }
  ],
  'k' : [
    { 
      image: MathK_2x,
      'Math': [
        'Counting & Comparison',
        'Addition & Subtraction',
        'Place Value & Number Sense',
        'Measurement & Data',
        'Geometry'
      ]
    },
    {
      image: ELAK_2x,
      'Reading': [
        'Letter Names and Sounds',
        'Letter Tracing',
        'CVC Words',
        'Rhyming Words',
        'Decodable Books',
        'Leveled Readers',
        'Sight Words'
      ]
    }
  ],
  '1' : [
    { 
      image: Math1_2x,
      'Math': [
        'Addition & Subtraction',
        'Place Value & Number Sense',
        'Time & Money',
        'Measurement & Data',
        'Geometry'
      ]
    },
    {
      image: ELA1_2x,
      'Reading': [
        'Blends & Digraphs',
        'Vowel Teams',
        'Rhyming Words',
        'Decodable Books',
        'Leveled Readers',
        'Sight Words'
      ]
    }
  ],
  '2' : [
    { 
      image: Math2_2x,
      'Math': [
        'Addition & Subtraction',
        'Place Value & Number Sense',
        'Time & Money',
        'Measurement & Data',
        'Geometry'
      ]
    },
    {
      image: ELA2_2x,
      'Reading': [
        'Triple Blends & Trigraphs',
        'Diphthongs',
        'Rhyming Words',
        'Decodable Books',
        'Leveled Readers',
        'Sight Words'
      ]
    }
  ],
  '3' : [
    { 
      image: Math3_2x,
      'Math': [
        'Addition & Subtraction',
        'Multiplication & Division',
        'Fraction',
        'Geometry',
        'Measurement & Data'
      ]
    }
  ],
  '4' : [
    { 
      image: Math4_2x,
      'Math': [
        'Addition & Subtraction',
        'Multiplication & Division',
        'Fraction',
        'Decimals',
        'Geometry',
        'Measurement & Data'
      ]
    }
  ],
  '5' : [
    {
      image: Math5_2x,
      'Math': [
        'Multiplication & Division',
        'Fraction',
        'Decimal Operations',
        'Geometry',
        'Measurement & Data'
      ]
    }
  ]
}